import {Box, Button, Grid} from "@mui/material";
import {GeolocateControl, Map, NavigationControl, Popup as PopupComponent, ScaleControl} from '@vis.gl/react-maplibre';
import {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";
import MapProjectLayer from "./MapProjectLayer";
import 'maplibre-gl/dist/maplibre-gl.css';
import useMobile from "../../hooks/useMobile";
import StylesControl from "../maps/StylesControl";
import {useDispatch, useSelector} from "react-redux";
import {addPin, removePin, resetInteractiveLayers} from "../../store/reducers/map";
import httpReq from "../../services/httpReq";
import {ColorPalette} from "../../consts/ColorPalette";
import {toggleProjectOpen} from "../../store/reducers/projects";
import * as lod from "lodash";
import MapTagsButton from "../buttons/MapTagsButton";

const OFFSET = [0, -10];

const MapContainer = () => {
    const navigate = useNavigate();
    const isMobile = useMobile();
    const dispatch = useDispatch();

    const mapStore = useSelector((state) => state.map);
    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);

    const [mapStyle, setMapStyle] = useState('openstreetmap');
    const [projects, setProjects] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tagValuesIds,setTagValuesIds] = useState([]);

    const mapKey = process.env.REACT_APP_API_KEY;
    const mapRef = useRef(null);

    useEffect(() => {
        if (isLoading || isLoaded) return;
        setIsLoading(true);
        dispatch(resetInteractiveLayers());
        httpReq('Project/GetList', 'GET', null, true).then(res => {
            if (!res || res.responseAnyError) return
            const items = [...res.responseData].map((item, k) => {
                const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === item.id) : null;
                item.color = ColorPalette[k];
                if (!foundProject) {
                    item = {...item, isOpen: false};
                    dispatch(toggleProjectOpen(item));
                }
                else {
                    item = {...item, isOpen: foundProject.isOpen};
                }
                return item;
            });
            const p = lod.orderBy(items, ['name'], 'asc');
            setProjects(p);
            setIsLoading(false);
            setIsLoaded(true);
        });
    }, [isLoaded, isLoading])



    const onMapClick = async (event) => {
        console.log('event.features ', event.features);


        if (!event.features) return;

        const feature = event.features[0];

        if (!feature) {
            return;
        }
        const clusterId = feature.properties.cluster_id;

        if (!mapRef.current) {
            return;
        }

        const geojsonSource = mapRef.current.getSource(feature.source);

        const zoom = await geojsonSource.getClusterExpansionZoom(clusterId);

        if (feature.layer.id.includes('unclustered-point-') || feature.layer.id.includes('begin-point-1')) {
            dispatch(addPin(feature));
        } else {
            mapRef.current?.flyTo({center: feature.geometry.coordinates, zoom, duration: 2000});
        }
        dispatch(addPin(feature))
    };

    useEffect(() => {
        if (!mapStore.goToCoords) return;
        mapRef.current?.flyTo({
            essential: true,
            center: [mapStore.goToCoords.longitude, mapStore.goToCoords.latitude],
            zoom: 15
        })
    }, [mapStore.goToCoords]);

    const handleSetStyle = style => setMapStyle(style)

    const visiblePins = useMemo(() => {

        console.log('mapStore ---> ',mapStore)
        if (mapStore.pins.length === 0) return <></>

        return (
            mapStore.pins.map(pin => {
                console.log('pin ',pin.geometry)
                if(pin.properties.type === 'begin' || pin.properties.type === 'end'){
                    const report = JSON.parse(pin.properties.report)
                    return (
                        <PopupComponent
                            offset={OFFSET.map(v => v * 1.5)}
                            longitude={Number(report.beginLongitude ?? report.longitude)}
                            latitude={Number(report.beginLatitude ?? report.latitude)}
                            closeButton={true}
                            focusAfterOpen={false}
                            closeOnClick={true}
                            onClose={() => {
                                dispatch(removePin(pin))
                            }}
                        >
                            <Box display='flex' flexDirection='column' alignItems='center'>
                                <Typography variant='body2'>Title:</Typography>
                                <Typography variant='h5'>{report.title}</Typography>
                                <br/>
                                <Typography variant='body2'>Description:</Typography>
                                <Typography fontWeight='bold' variant='body1'>{report.description}</Typography>
                                {/* {!isEditing && (user.type === 1 || */}
                                <Button
                                    variant='outlined'
                                    size='small'
                                    sx={{mt: 1, color: 'white'}}
                                    onClick={() => {
                                        navigate('/project/edit/' + report.video.project.id + '/video/' + report.video.id + '/report/' + report.id)
                                    }}
                                >
                                    {'VIEW'}
                                </Button>

                            </Box>
                        </PopupComponent>
                    )
                } else {
                    const coords = [Number(pin.geometry.coordinates[0]), Number(pin.geometry.coordinates[1])];

                    mapRef.current?.flyTo({
                        center: coords,
                        zoom: 15,
                        duration: 2000,
                        essential: true
                    });
                }

            })
        )

    }, [mapStore.pins])

    useEffect(() => {
        setIsLoaded(false);
    }, [localStorageProjects]);

    return (
        <Grid container sx={{height: '100%', width: '100%'}}>
            <Grid xs={12}>
                <Map
                    initialViewState={{
                        latitude: process.env.REACT_APP_CENTER_LAT,
                        longitude: process.env.REACT_APP_CENTER_LON,
                        zoom: 5
                    }}
                    style={{width: 'auto', height: '100%'}}
                    mapStyle={`https://api.maptiler.com/maps/${mapStyle}/style.json?key=${mapKey}`}
                    interactiveLayerIds={[...mapStore.interactiveLayers]}
                    onClick={(e) => onMapClick(e)}
                    ref={mapRef}
                >
                    <NavigationControl position='bottom-right'/>
                    <GeolocateControl
                        position='bottom-right'
                        trackUserLocation={isMobile}
                        showUserLocation={true}
                        showAccuracyCircle={isMobile}
                        positionOptions={{enableHighAccuracy: true}}
                    />
                    <MapTagsButton setTagValuesIds={setTagValuesIds}/>
                    <ScaleControl/>
                    <StylesControl handleSetStyle={handleSetStyle} position='middle-right'/>
                    {projects && projects.length > 0 && (
                        projects.filter(p=> p.isOpen===true).map(project => {
                            return (
                                <MapProjectLayer tagValuesIds={tagValuesIds} key={'key-project-layer-' + project.id} project={project}/>
                            )
                        })
                    )}
                    {mapStore.pins && mapStore.pins.length > 0 && visiblePins}
                </Map>
            </Grid>
        </Grid>
    )
}

export default MapContainer;